/** Shared public reading/preview presentation. Saved policy text is always React text,
 * never trusted HTML. Heading prefixes apply only to their first line. */
export function PolicyBody({ body }: { body: string }) {
  return <div className="policy-body">{body.split(/\n{2,}/).map((block, index) => {
    const lines = block.trim().split("\n");
    if (!lines[0]) return null;
    const heading = /^(#{1,2}) (.*)$/.exec(lines[0]);
    const content = heading ? lines.slice(1).join("\n").trim() : block.trim();
    return <div key={index}>
      {heading && <h2 className="mt-6 mb-2 text-lg font-bold text-navy">{heading[2]}</h2>}
      {content && (content.split("\n").every((line) => line.startsWith("- "))
        ? <ul className="list-disc space-y-2 pl-5">{content.split("\n").map((line, lineIndex) => <li key={lineIndex}>{line.slice(2)}</li>)}</ul>
        : <p className="mb-4 whitespace-pre-line">{content}</p>)}
    </div>;
  })}</div>;
}
